<div class="one temp-height height-525 overflow-x-auto" fxLayout="row">
  <div>
    <div class="shadow1">
      <div class="header-title">Password</div>
      <!-- matButton="filled" hover:!bg-gray-50 !bg-white !text-black -->
      <!-- <button
                mat-raised-button
                (click)="ChangePass()"
                class="!shadow-md chng-pwd"
            > -->
      <!-- class="!bg-white !text-black !border !border-gray-300 !shadow-md hover:!bg-gray-50" -->
      <button class="pass-button" (click)="ChangePass()">Change your password</button>
    </div>
    <br />
    <div class="shadow2">
      <div class="header-title">
        Multi Factor Authentication
        <span [ngClass]="AWAITING2FA == 'true' ? 'btn-on' : 'btn-off'">
          {{ AWAITING2FA == 'true' ? 'On' : 'Off' }}
        </span>
      </div>
      <h4 style="margin-bottom: 0px" class="text-[15px]">
        After entering your password, on login, verify your identity with an authentication method.
      </h4>
      <br />
      <!-- <div>
        <button *ngIf="AWAITING2FA == 'false' || AWAITING2FA == 'default'" mat-raised-button style="font-weight: 600;" (click)="targetNewTab('/multi-factor-authentication', 'MULTIFACTORAUTHENTICATION')">Set up multi-factor authentication</button>
      </div><br> -->
      @if (AWAITING2FA == 'true') {
        <div class="border-line"></div>
      }
      <br />
      @if (AWAITING2FA == 'true') {
        <div class="header-title-2">Primary method</div>
      }
      @if (AWAITING2FA == 'true') {
        <h3 style="font-weight: 600">Use the Google Authenticator to generate a secure code</h3>
      }
      @if (AWAITING2FA == 'true') {
        <div class="auth-div">
          <div class="text-div">
            <img src="assets/icons/web_app/Google Auth.webp" />
            <span>Google Authenticator</span>
          </div>
          <div class="text-div">
            <button mat-button>Turn Off</button>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="sec-div">
    <app-multi-factor-authentication></app-multi-factor-authentication>
  </div>
</div>
